import { AppBridge } from '@/assets/js/common'
import { store } from '@/store/index'

// 네비게이션 전역가드
export const NaviGuard = function (router) {
  const isNative = navigator.userAgent.toLowerCase().includes('native')

  router.beforeEach(async (to, from, next) => {
    // 검색 데이터 제거
    const searchKeepRouter = ['Search', 'ProductDetail', 'Planning']
    if (!searchKeepRouter.includes(from.name)) {
      sessionStorage.removeItem('searchObj')
    }

    // 라우터가드 인증
    if (to.matched.some((routerInfo) => {
      return routerInfo.meta.authRequired
    })) {
      const token = sessionStorage.getItem('accessToken')
      if (!token) {
        if (to.name !== 'MyPage') {
          alert('로그인이 필요한 서비스 입니다.') 

          if (from.name === 'Login') { return false }
          
          sessionStorage.setItem('landingPage', to.path)
          return router.push('/Login')
        }
      } else {
        await store.dispatch('userStore/snsAddInfoChk', token)
      }
    }
    
    if (isNative) { AppBridge.send('routing', { value: to.name }, true) }

    
    if (!window.TokenService) return next()

    let result = await window.TokenService._watchToken()
    if (!result) { next() }
    else window.location.replace('/demo')
  })
}